import sdk from './vue-sdk'

sdk.setAppid('20251209095431GkKnUZrsPBChWCzIMt')

if(localStorage.getItem('userInfo')) {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    const token = localStorage.getItem('token')
    if(userInfo && token) {
        sdk.login(userInfo.mobile, userInfo.email)
        console.log(sdk.login(userInfo.mobile, userInfo.email))
    }
}

sdk.setCarried('pc')

const sdkClick = (title, value) => {
    sdk.click(title, value)
}

const sdkTime = (title, value, stayTime) => {
    sdk.time(title, value, stayTime)
}

export{ sdkClick, sdkTime }
